module.exports = __webpack_public_path__ + "img/Logo-DarkBg.fa01de8e.png";